import { useQuery } from '@apollo/client/react'
import { useEffect, useState } from 'react'

import { CHECK_VOUCHER } from 'api/symfony/graphql/queries/checkVoucher'

interface VoucherCheckResult {
  voucherCheck?: {
    valid: boolean
    newContract?: { id: string }
  }
}

export function useVoucherCheck(
  contractId: string | null,
  initialVoucherCode?: string
) {
  const [voucherValue, setVoucherValueState] = useState<string>(
    initialVoucherCode ?? ''
  )
  const [voucherCodeToCheck, setVoucherCodeToCheck] = useState<string | null>(
    null
  )
  const [voucherValid, setVoucherValid] = useState<boolean | null>(
    initialVoucherCode?.trim().length ? true : null
  )

  const { data: checkVoucherData, loading: voucherLoading } = useQuery(
    CHECK_VOUCHER,
    {
      skip: voucherCodeToCheck === null,
      variables: {
        code: voucherCodeToCheck ?? '',
        contractId: contractId ?? '',
      },
      fetchPolicy: 'cache-and-network',
    }
  )

  const result = (checkVoucherData as VoucherCheckResult | undefined)
    ?.voucherCheck

  useEffect(() => {
    if (result !== undefined) {
      setVoucherValid(result.valid)
    }
  }, [result])

  useEffect(() => {
    if (initialVoucherCode?.trim().length) {
      setVoucherValid(true)
    }
  }, [initialVoucherCode])

  function setVoucherValue(value: string) {
    const trimmed = value.trim()
    setVoucherValueState(trimmed)
    setVoucherCodeToCheck(null)
    setVoucherValid(null)
  }

  function triggerCheck() {
    if (voucherValue.trim()) {
      setVoucherCodeToCheck(voucherValue.trim())
    }
  }

  const newContractId = result?.newContract?.id ?? null

  return {
    voucherValid,
    voucherLoading,
    voucherValue,
    setVoucherValue,
    triggerCheck,
    newContractId,
  }
}
